<template>
    <div
class="flex justify-center items-center px-2 py-1 rounded-full  "
        :class="disabled ? 'shadow-none bg-[#E5E5E5]' : 'shadow-[0px_0px_10px_0px_#00000026] bg-[#fff]'"
>
        <span
type="button" :class="[
            'mobile:!bg-transparent tablet:text-xl mobile:!h-full mobile:!w-auto tablet:h-8 tablet:w-8 rounded-full mobile:leading-[1.5] tablet:leading-[1.6] text-center hover:text-white',
            disabled ? 'cursor-not-allowed pointer-events-none text-white' : (quantity > 1 ? 'text-purple-500 hover:bg-purple-500' : 'text-rose-400 hover:bg-rose-400')
        ]" @click="!disabled && decrementCount()"
>
            <div v-if="quantity > 1">
                <div v-if="isTabletOrAbove || disabled" class="group !h-8 !w-8 flex items-center justify-center">
                    <font-awesome-icon icon="minus" class="group-hover:hidden" />
                    <img
src="../../assets/images/minus-icon-with-bg.svg" alt="Cart Icon"
                        class="!h-8 !w-8 hidden group-hover:!block"
>
                </div>
                <img v-else src="../../assets/images/minus-icon-with-bg.svg" alt="Cart Icon" class="!h-8 !w-8">
            </div>

            <div
v-else-if="isTabletOrAbove || disabled"
                class="group flex items-center justify-center h-full p-1 rounded-full hover:bg-[#f67280]"
>
                <img
src="../../assets/images/trash-icon-updated.png" alt="Cart Icon" :class="['!w-7 !h-7 group-hover:hidden',
                    disabled ? 'cursor-not-allowed pointer-events-none hidden' : '']"
>
                <img
src="../../assets/images/trash-icon-white-updated.png" alt="Cart Icon" :class="['!w-7 !h-7 hidden group-hover:!block',
                    disabled ? 'cursor-not-allowed pointer-events-none !block' : ''
                ]"
>
            </div>
            <div v-else class="rounded-full bg-transparent flex items-center justify-center h-full">
                <img src="../../assets/images/delete-icon-with-bg.svg" alt="Cart Icon" class="!h-8 !w-8">
            </div>
        </span>
        <input
type="text" name="count" :value="quantity" readonly :class="[
            'w-[70px] h-[35px] mobile:px-2 mobile:py-1 tablet:p-2 text-center text-xl  focus:outline-0 bg-transparent',
            disabled ? 'text-white cursor-not-allowed pointer-events-none' : '']"
>
        <span
type="button" :class="[
            'mobile:!bg-transparent tablet:text-xl tablet:h-8 tablet:w-8 rounded-full mobile:leading-[1.4] tablet:leading-[1.6] text-center text-purple-500 hover:bg-purple-500 hover:text-white',
            disabled ? 'text-white cursor-not-allowed pointer-events-none' : ''
        ]" @click="!disabled && incrementCount()"
>
            <div v-if="isTabletOrAbove || disabled" class="group !h-8 !w-8 flex items-center justify-center">
                <font-awesome-icon icon="plus" class="group-hover:hidden" />
                <img
src="../../assets/images/plus-icon-with-bg.svg" alt="Cart Icon"
                    class="!h-8 !w-8 hidden group-hover:!block"
>
            </div>
            <img v-else src="../../assets/images/plus-icon-with-bg.svg" alt="Cart Icon" class="!h-8 !w-8">
        </span>
    </div>
</template>

<script>
export default {
    props: ["quantity", "product", "disabled"],
    data() {
        return {
            isTabletOrAbove: window.innerWidth >= 768,
        };
    },
    mounted() {
        window.addEventListener('resize', this.checkScreenSize);
    },
    beforeUnmounted() {
        window.removeEventListener('resize', this.checkScreenSize);
    },
    methods: {
        incrementCount() {
            this.$emit('update-counter', "increment", this.product)
            // this.count++;
        },
        decrementCount() {
            this.$emit('update-counter', "decrement", this.product)
            // if (this.count > 1) {
            //     this.count--
            // } else {
            //     this.$emit('hide-counter')
            // }
        },
        checkScreenSize() {
            this.isTabletOrAbove = window.innerWidth >= 768;
        },
    },
};
</script>
